import { useQuery, gql, useLazyQuery } from '@apollo/client';
import {
  ProjetoDisciplinasQuery,
  ProjetoDisciplinasQueryVariables,
} from './__generated__/ProjetoDisciplinasQuery';

const DISCIPLINAS_QUERY = gql`
  query ProjetoDisciplinasQuery($descricao: String, $pagina: Int, $itens_por_pagina: Int) {
    disciplinas(
      filter: { descricao: $descricao, pagina: $pagina, itens_por_pagina: $itens_por_pagina }
    ) {
      id_disciplina
      dsc_nome_disciplina
      dsc_sigla
      dsc_ementa
      num_carga_horaria
    }
  }
`;

const useDisciplinasQuery = (variables: ProjetoDisciplinasQueryVariables) => {
  return useQuery<ProjetoDisciplinasQuery, ProjetoDisciplinasQueryVariables>(DISCIPLINAS_QUERY, {
    variables,
  });
};

const useDisciplinasLazyQuery = () => {
  return useLazyQuery<ProjetoDisciplinasQuery, ProjetoDisciplinasQueryVariables>(DISCIPLINAS_QUERY);
};

export { useDisciplinasQuery, useDisciplinasLazyQuery };
